import React from "react";
import { Modal } from "react-bootstrap";

const ViewOtherServices = ({
  show,
  onHide,
  cart,
  jobItems,
  apiData,
  selectViewMore,
  switchService,
}) => {
  const filteredValues = apiData?.variants.filter((item) => {
    return !jobItems.some((job) => job.JourneyVariantId === item.Id);
  });

  let { products} = cart;

  let excludedVariantIds = [];
  for (let i = 0; i < products?.length; i++) {
    if (products[i]?.ExcludeVariants?.length !== 0) {
      for (let j = 0; j < products[i]?.ExcludeVariants?.length; j++) {
        excludedVariantIds.push(
          products[i].ExcludeVariants[j].ExcludeJourneyVariantId
        );
      }
    }
  }

  return (
    <Modal
      show={show}
      onHide={() => onHide()}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <p class="mr-service-blk-ttl p-0 m-0  " id="exampleModalLabel">
          More services from {cart?.workshop?.Name}
        </p>
      </Modal.Header>
      <Modal.Body>
        <div>
          <ul class="othr-grg-serv">
            {filteredValues.map((e) => {
              return (
                <li>
                  <div>
                    <h3>{e.Name}</h3>
                    <span class="red-val">
                      {" "}
                      {e.CostBeforeOffer > 0 && e.CostBeforeOffer != e.Cost && (
                        <del className="mr-1" style={{ color: "#848484" }}>
                          AED {e.CostBeforeOffer}
                        </del>
                      )}
                      {"AED " + e.Cost}
                    </span>
                  </div>
                  <label class="action-bar">
                    {excludedVariantIds.includes(e.Id) &&
                    cart.jobItems.length !== 0 ? (
                      <button
                        onClick={() => {
                          switchService(e);
                          onHide();
                        }}
                        class="srv-act-action"
                      >
                        Switch
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          selectViewMore(e);
                          onHide();
                        }}
                        class="srv-act-action"
                      >
                        Select
                      </button>
                    )}
                    <span>Know more</span>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewOtherServices;
